import { DayTableColumns } from './day-table-columns';
import { TextKeys } from '../../i18n/text-keys';
import { TableColumn } from '../../models/table-column';

export function getTableColumns(): TableColumn[] {
  return [
    {
      name: DayTableColumns.K,
      position: 0,
      selected: true,
      text: TextKeys.dayInfo.changeIndicator,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.Time,
      position: 1,
      selected: true,
      text: TextKeys.dayInfo.dateTime,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.Hours,
      position: 2,
      selected: true,
      text: TextKeys.dayInfo.hours,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.Konto,
      position: 3,
      selected: true,
      text: TextKeys.absence.konto,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.Absence,
      position: 4,
      selected: true,
      text: TextKeys.absence.title,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.OrderNr,
      position: 5,
      selected: true,
      text: TextKeys.order.numberLong,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.OrderName,
      position: 6,
      selected: true,
      text: TextKeys.order.name,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.costCenterNumber,
      position: 7,
      selected: true,
      text: TextKeys.costCenter.numberShort,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.CostCenterName,
      position: 8,
      selected: true,
      text: TextKeys.costCenter.title,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.KSatz,
      position: 9,
      selected: true,
      text: TextKeys.dayInfo.ksatz,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.Operation,
      position: 10,
      selected: true,
      text: TextKeys.operation.title,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.FullAbsenceTimeEntry,
      position: 11,
      selected: false,
      text: TextKeys.dayInfo.fullAbsence,
      alternativeDisplayText: TextKeys.absence.title,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.FullWorkTimeEntry,
      position: 12,
      selected: false,
      text: TextKeys.dayInfo.fullWork,
      alternativeDisplayText: TextKeys.dayInfo.workInfoTitle,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.FullDate,
      position: 13,
      selected: false,
      text: TextKeys.dayInfo.fullDate,
      alternativeDisplayText: TextKeys.dayInfo.date,
      disabled: false,
    } as TableColumn,
    {
      name: DayTableColumns.Date,
      position: 14,
      selected: false,
      text: TextKeys.dayInfo.date,
      disabled: false,
    } as TableColumn,
  ];
}

export function getColumnsChronoStandard(): TableColumn[] {
  const columns = getTableColumns();

  const disabledColumns = [
    DayTableColumns.CostCenterName,
    DayTableColumns.FullWorkTimeEntry,
    DayTableColumns.Operation,
    DayTableColumns.OrderName,
    DayTableColumns.OrderNr,
    DayTableColumns.costCenterNumber,
    DayTableColumns.KSatz,
  ];

  columns.forEach((column) => {
    if (disabledColumns.includes(column.name as DayTableColumns)) {
      column.disabled = true;
      column.selected = false;
    }
  });

  // sort by disabled, position.
  columns.sort((c1, c2) => {
    if (c1.disabled && !c2.disabled) {
      return 1;
    }
    if (!c1.disabled && c2.disabled) {
      return -1;
    }
    return c1.position < c2.position ? -1 : 1;
  });

  columns.forEach((column, index) => {
    column.position = index;
  });

  return columns;
}
